import React, { useState } from "react"
import PropTypes from "prop-types"
import { StyledField } from "./styles"
import Button from "../../button"
import { P } from "../../typography"
import Grid from "../../grid"

const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB in bytes

const FileField = ({ handleInputChange, name, text, noneText, accept, required, multiple, alert }) => {
  const [selectedText, setSelectedText] = useState(noneText)

  const onChange = (event) => {
    const { files } = event.target
    !!multiple ? handleMultipleFiles(files) : handleSingleFile(files[0])
  }

  const handleMultipleFiles = (files) => {
    const fileArray = Array.from(files)
    setSelectedText(`${fileArray.length} ${fileArray.length === 1 ? "file" : "files"} selected`)

    // Is this needed?
    // fileArray.forEach(file => {
    //   let reader = new FileReader()
    //   if (file instanceof Blob) reader.readAsDataURL(file)
    // })

    if (handleInputChange !== undefined) handleInputChange(name, fileArray)
  }

  const handleSingleFile = (file) => {
    if (file?.size >= MAX_FILE_SIZE && alert !== undefined) {
      handleInputChange(name, null)
      alert.error("Chosen file is above file limit")
      return
    }

    let reader = new FileReader()
    reader.onload = () => {
      const text = document.getElementById(`${name}SelectedText`)
      setSelectedText(file.name)
      text.setAttribute("data-reader-result", reader.result)
      if (handleInputChange !== undefined) handleInputChange(name, file)
    }
    if (file instanceof Blob) reader.readAsDataURL(file)
  }

  const triggerFileUpload = (event) => {
    event.preventDefault()
    document.getElementById(`${name}FileField`).click()
  }

  return (
    <>
      <Grid gap="1rem" grid="auto / auto-flow" placeItems="center" placeContent="start">
        <Button variant="secondary" onClick={triggerFileUpload}>
          {text}
        </Button>
        <P marginless id={`${name}SelectedText`}>
          {selectedText}
        </P>
      </Grid>
      <StyledField
        type="file"
        name={name}
        accept={accept}
        required={required}
        multiple={multiple}
        onChange={onChange}
        id={`${name}FileField`}
      />
    </>
  )
}

FileField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  text: PropTypes.string,
  noneText: PropTypes.string,
  accept: PropTypes.string,
  required: PropTypes.bool,
  multiple: PropTypes.bool
}

FileField.defaultProps = {
  handleInputChange: undefined,
  name: "",
  text: "Choose file",
  noneText: "No file selected",
  accept: "application/pdf",
  required: false,
  multiple: false
}

export default FileField
